import React, { useEffect, useState } from 'react';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@ohif/ui-next';
import { useSearchParams } from 'react-router-dom';

const API_BASE_URL = process.env.API_BASE_URL;

const SelectSite = ({ userAuthenticationService, clearFilters }) => {
  const [options, setOptions] = useState([]);
  const [siteId, setSiteId] = useState(null);
  const [searchParams] = useSearchParams();

  const fetchSites = async () => {
    const token =
      userAuthenticationService.getAuthorizationHeader()?.Authorization ||
      searchParams.get('token');

    if (!token) {
      return;
    }

    const response = await fetch(API_BASE_URL + '/user/me', {
      method: 'GET',
      headers: {
        Authorization: token,
      },
    });
    const { sites }: any = await response.json();
    setOptions(sites.map(s => ({ value: s.siteId, label: s.name })));

    if (!window.sessionStorage.getItem('siteId')) {
      sessionStorage.setItem('siteId', sites[0].siteId);
      window.dispatchEvent(new Event('storage'));
      setSiteId(sites[0].siteId);
    } else {
      setSiteId(window.sessionStorage.getItem('siteId'));
    }
  };
  useEffect(() => {
    fetchSites();
  }, []);

  const onValueChange = value => {
    clearFilters();
    sessionStorage.setItem('siteId', value);
    setSiteId(value);
    window.dispatchEvent(new Event('storage'));
    // window.location.reload();
  };

  return (
    <Select
      value={siteId}
      onValueChange={onValueChange}
    >
      <SelectTrigger className="w-[180px] truncate">
        <SelectValue placeholder="Select site" />
      </SelectTrigger>
      <SelectContent>
        {options.map(o => {
          return <SelectItem value={o.value}>{o.label}</SelectItem>;
        })}
      </SelectContent>
    </Select>
  );
};

export default SelectSite;
